<template>
  <div>
    <b-tooltip
      label="Cargando datos necesarios"
      position="is-top"
      :active="
        tableReportBedStateData == null && tableReportBedCovidData == null
      "
    >
      <b-button
        class="button field is-primary is-small"
        @click="openSaveReport()"
        icon-left="save"
        v-if="!hideButton"
        :loading="
          tableReportBedStateData == null && tableReportBedCovidData == null
        "
      >
        Guardar reporte
      </b-button>
    </b-tooltip>
    <b-table
      :data="reports"
      :loading="isLoading"
      :total="total"
      paginated
      :per-page="perPage"
      :current-page.sync="currentPage"
      @page-change="onPageChange"
      backend-pagination
    >
      <b-table-column field="date_report" label="Fecha" v-slot="props">
        {{ props.row.created_at }}
      </b-table-column>
      <b-table-column field="user_id" label="Responsable" v-slot="props">
        {{ props.row.user.name }} {{ props.row.user.apepat }}
        {{ props.row.user.apemat }}
      </b-table-column>
      <b-table-column field="action" label="Acciones" v-slot="props">
        <b-button
          type="is-primary"
          icon-left="eye"
          @click="openModalStateReport(props.row)"
          >Visualizar reporte</b-button
        >
      </b-table-column>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="frown-open" size="is-large"></b-icon>
            </p>
            <p>No hay reportes creados</p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
import { eventBus } from "../../main";
import { getDailyReports } from "./../../services/daily_report";
import SaveReport from "./SaveReport";
import ModalStateBedReport from "./ModalStateBedReport";
export default {
  props: ["hideButton"],
  data() {
    return {
      reports: [],
      isLoading: true,
      tableReportBedStateData: null,
      tableReportBedCovidData: null,
      total: 0,
      perPage: 0,
      currentPage: 1,
      page: 1
    };
  },
  async mounted() {
    eventBus.$on("emitJsonBedStateReport", (json) => {
      console.log("bedStateReport");
      console.log(json);
      this.tableReportBedStateData = json;
    });
    eventBus.$on("emitJsonBedCovidReport", (json) => {
      console.log("covidReport");
      console.log(json);
      this.tableReportBedCovidData = json;
    });
    await this.getReports();
  },
  methods: {
    onPageChange(page) {
      this.page = page;
      this.getReports();
    },
    async getReports() {
      this.isLoading = true;
      let reportResponse = await getDailyReports(this.$http, this.page);
      this.reports = reportResponse.data;
      this.total = reportResponse.total;
      this.perPage = reportResponse.per_page;
      this.currentPage = reportResponse.current_page;
      console.log(this.reports);
      this.isLoading = false;
    },
    openModalStateReport(dailyReport) {
      let reportData = JSON.parse(dailyReport.report).tableReportBedStateData;
      this.$buefy.modal.open({
        parent: this,
        component: ModalStateBedReport,
        width: 1100,
        props: {
          tableData: reportData,
          dailyReport: dailyReport,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    openSaveReport() {
      this.$buefy.modal.open({
        parent: this,
        component: SaveReport,
        props: {
          tableReportBedStateData: this.tableReportBedStateData,
          tableReportBedCovidData: this.tableReportBedCovidData,
          getReports: this.getReports,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
  },
};
</script>

<style>
</style>